// extracted by mini-css-extract-plugin
export var cardLayout = "_6c-1";
export var paginationContainer = "_6c-0";